import React from 'react'
import styles from './PaymentView.module.css'
import TextInput from '../TextInput';
import CustomButton from '../CustomButton'
import { paymentConfig } from '../../../../shared/project-info/paymentConfig';
import { userProfile } from '../../../../shared/models/UserProfile';
import { withRouter } from 'react-router-dom';
import { PERSONAL_INFO_PROPS } from '../../../../shared/constants/RadioProps';
import { Modal, Box } from '@material-ui/core';

import moment from 'moment';
import { logPayForShirt } from '../../../../shared/models/Analytics';
import { isNullOrEmpty, validateEmail, isMilitaryAddress } from '../../../../shared/utils/Helpers';
import { COUNTRY_OPTIONS } from '../../../../shared/constants/Countries';
import {
  confirmPaymentIntent,
  createPaymentMethod,
} from '../../../../shared/apis/stripe-api';
import {
  GENERIC_ERROR,
} from '../../../../shared/constants/ErrorMessages';
import { rwbApi } from '../../../../shared/apis/api';
import RadioForm from '../RadioForm';
import AddressesList from './AddressesList';
import { RADIO_PROPS } from '../../../../shared/constants/RadioProps';
import { melissaLookup, melissaVerify } from '../../../../shared/utils/MelissaHelper';
import debounce from 'lodash.debounce';
import ShirtSizesModal from '../registration/ShirtSizesModal';

const { sizes_radio_props } = RADIO_PROPS;
const { address_type_radio_props } = PERSONAL_INFO_PROPS;
const DEBOUNCE_MS = 500;
export class PaymentView extends React.Component {
  constructor(props) {
    super(props);
    const complete_user = userProfile.getUserProfile();
    const current_user = userProfile.getUserProfile();

    this.state = {
      shirt_size: null,
      shirt_size_error_text: '',
      alternate_shirt_address: false,
      manual_shirt_address: false,
      shirt_address_general_error_text: '',
      shirt_address_city: '',
      shirt_address_city_error_text: '',
      shirt_address_state: '',
      shirt_address_state_error_text: '',
      shirt_address_street: '',
      shirt_address_street_error_text: '',
      shirt_address_apartment: '',
      shirt_address_zip: '',
      shirt_address_zip_error_text: '',
      shipping_country: "",
      shirt_address_country_error_text: '',
      server_error_text: '',
      current_user,
      fullAddress: '',
      showCountryModal: false,
      address_type: current_user?.location?.address_type,
      user_email: complete_user.email,
      user_name: `${complete_user.first_name} ${complete_user.last_name}`,

      payment_state: '', // state can be "authorizing" (payment started), "complete" (payment went through),
      // "invalid" (wrong input), and "declined" (something is wrong with the card). The "complete" state indicates the card payment went through
      card_number: '',
      card_number_error_text: '',
      card_expiration: '',
      card_expiration_error_text: '',
      card_cvv: '',
      card_cvv_error_text: '',
      card_zip:
        current_user?.location?.country &&
          current_user?.location?.country.toLowerCase() === 'united states'
          ? current_user?.location?.zip?.slice(0, 5)
          : current_user?.location?.zip,
      card_zip_error_text: '',
      validationURL: '',
      showMelissaModal: false,
      showApartmentModal: false,
      apartmentList: [],
      id: this.props.location.state.id,
      title: this.props.location.state.title,
      price: this.props.location.state.price,
      icon: this.props.location.state.icon,
      expiration_date: '',
      amount_paid: 0,
      city: current_user?.location?.city,
      zip: current_user?.location?.zip,
      shippingAddressState: current_user?.location?.address_state,
      showShirtSizeModal: false
    };

    this.user_id = ''; // RWB user id to be used for logging
    this.payment_intent_id = '';
    this.pagesLoaded = 0; // the url for stripe validation has multiple on changes before loading the page we want
    this.receiptEmail = ''; // the email that will be receiving the receipt
  }
  getMembershipExpireDate = () => {
    return moment().add(184, 'days').format('MM/DD/YYYY');
  };
  valueChangeHandler = (event, field) => {
    this.setState({ [field]: event.target.value });
  };

  displayCardNumber(text) {
    let formattedText = text.split(' ').join('');
    if (formattedText.length > 16) {
      formattedText = formattedText.substr(0, 16);
    }
    if (formattedText.length > 0) {
      formattedText = formattedText.match(new RegExp('.{1,4}', 'g')).join(' ');
    }
    return formattedText;
  }

  setCardNumber = (text) => {
    let value = text.target.value
    if (value.length <= 19)
      this.setState({ card_number: value.replace(/([^0-9 ])+/i, "") });
  };
  insertCharBefore = (text, split, char) => {
    return text.slice(0, split) + char + text.slice(split, text.length);
  };
  setExpirationDate = (text) => {
    if (
      text.length >= 3 &&
      text.charAt(2) !== '/' &&
      text.length >= this.state.card_expiration.length
    ) {
      text = this.insertCharBefore(text, 2, '/');
    }
    if (text.length > 5) {
      text = text.substring(0, 5);
    }
    return text;
  };
  handleCardCvv = (event) => {
    let cvv = event.target.value;
    if (cvv.length <= 4)
      this.setState({ card_cvv: cvv })

  }

  isExpiredCard = (expirationDate) => {
    const month = parseInt(expirationDate.split('/')[0]);
    const year = parseInt(expirationDate.split('/')[1]);
    const curDate = new Date();
    const curMonth = curDate.getMonth() + 1;
    const curYear = parseInt(curDate.getFullYear().toString().slice(-2));
    if (year < curYear) return true;
    else if (year === curYear) return month < curMonth;
    else return false;
  };
  clearWarnings() {
    this.setState({
      shirt_size_error_text: null,
      shirt_address_city_error_text: null,
      shirt_address_general_error_text: null,
      shirt_address_state_error_text: null,
      shirt_address_zip_error_text: null,
      shirt_address_street_error_text: null,
      email_error_text: null,
      card_number_error_text: null,
      card_expiration_error_text: null,
      card_cvv_error_text: null,
      card_zip_error_text: null,
    });
  }

  validateInput = () => {
    let {
      shirt_size,
      alternate_shirt_address,
      manual_shirt_address,
      shirt_address_city,
      shirt_address_street,
      shirt_address_state,
      shirt_address_zip,
      user_email,
      user_name,
      card_number,
      card_expiration,
      card_cvv,
      card_zip,
    } = this.state;
    card_number = card_number.replaceAll(/\s/g, '')

    let hasError = false;
    this.clearWarnings()

    if (paymentConfig.hasShipment) {
      if (shirt_size === null) {
        this.setState({ shirt_size_error_text: 'PLEASE SELECT A SHIRT SIZE' });
        hasError = true;
      }
      if (alternate_shirt_address && !manual_shirt_address) {
        if (
          !shirt_address_city ||
          !shirt_address_state ||
          !shirt_address_street ||
          !shirt_address_zip
        ) {
          this.setState({
            shirt_address_general_error_text: 'YOU MUST FILL OUT ALL FIELDS',
          });
          hasError = true;
        }
      } else if (alternate_shirt_address && manual_shirt_address) {
        if (!shirt_address_city) {
          this.setState({
            shirt_address_city_error_text: 'PLEASE ENTER YOUR CITY',
            shirt_address_general_error_text: 'YOU MUST FILL OUT ALL FIELDS',
          });
          hasError = true;
        }
        if (!shirt_address_street) {
          this.setState({
            shirt_address_street_error_text: 'PLEASE ENTER YOUR STREET ADDRESS',
            shirt_address_general_error_text: 'YOU MUST FILL OUT ALL FIELDS',
          });
          hasError = true;
        }
        if (!shirt_address_state) {
          this.setState({
            shirt_address_state_error_text: 'PLEASE ENTER YOUR STATE',
            shirt_address_general_error_text: 'YOU MUST FILL OUT ALL FIELDS',
          });
          hasError = true;
        }
        if (!shirt_address_city) {
          this.setState({
            shirt_address_zip_error_text: 'PLEASE ENTER YOUR ZIP CODE',
            shirt_address_general_error_text: 'YOU MUST FILL OUT ALL FIELDS',
          });
          hasError = true;
        }
      }
    }
    if (isNullOrEmpty(user_name)) {
      this.setState({ card_name_error_text: 'REQUIRED' });
      hasError = true;
    }
    if (isNullOrEmpty(user_email)) {
      this.setState({ email_error_text: 'REQUIRED' });
      hasError = true;

    } else if (!validateEmail(user_email)) {
      this.setState({ email_error_text: 'INVALID EMAIL ADDRESS' });
      hasError = true;
    }

    if (isNullOrEmpty(card_number)) {

      this.setState({ card_number_error_text: 'REQUIRED' });
      hasError = true;
    } else if (card_number.length < 14 || card_number.length > 16) {
      this.setState({ card_number_error_text: 'INVALID CARD NUMBER' });
      hasError = true;
    }
    if (isNullOrEmpty(card_expiration)) {
      this.setState({ card_expiration_error_text: 'REQUIRED' });
      hasError = true;
    } else if (card_expiration.length !== 5) {
      this.setState({
        card_expiration_error_text: 'DATE FORMAT SHOULD BE MM/YY',
      });
      hasError = true;
    } else if (!moment(card_expiration, 'MM-YY').isValid()) {
      this.setState({ card_expiration_error_text: 'INVALID EXP DATE' });
      hasError = true;
    } else if (this.isExpiredCard(card_expiration)) {
      this.setState({ card_expiration_error_text: 'EXPIRED CREDIT CARD' });
      hasError = true;
    }
    if (isNullOrEmpty(card_cvv)) {
      this.setState({ card_cvv_error_text: 'REQUIRED' });
      hasError = true;
    } else if (card_cvv.length < 3 || card_cvv.length > 4) {
      this.setState({ card_cvv_error_text: 'INVALID CVV' });
      hasError = true;
    }
    if (isNullOrEmpty(card_zip)) {
      this.setState({ card_zip_error_text: 'REQUIRED' });
      hasError = true;
    }

    if (hasError) {
      return
    }
    this.uploadUserInfo();

  }


  uploadUserInfo = () => {
    this.setState({ payment_state: 'authorizing' });

    const {
      shirt_size,
      alternate_shirt_address,
      shirt_address_street,
      shirt_address_apartment,
      shirt_address_city,
      shirt_address_state,
      shirt_address_zip,
      shipping_country,
    } = this.state;

    let value = this.state.current_user;
    Object.assign(value, {
      shirt_size,
      alternate_shirt_address,
      shipping_country: shipping_country, //should always be United States since international shipping is not supported
      shipping_street: shirt_address_street,
      // shipping_street_2: shirt_address_apartment, // not available backend
      shipping_city: shirt_address_city,
      shipping_state: shirt_address_state,
      shipping_zip: shirt_address_zip,
    });
    this.createIntent();
  };

  getCountrySlug(countryDisplay) {
    if (countryDisplay.length === 2) return countryDisplay; // currently looks like even country display is the two character code
    for (let property in COUNTRY_OPTIONS) {
      if (COUNTRY_OPTIONS[property].display === countryDisplay)
        return COUNTRY_OPTIONS[property].value;
    }
  }


  updateErrorStateFromServer(error) {
    if (error.code === 'incorrect_number' || error?.code === 'invalid_number')
      this.setState({
        card_number_error_text: 'INVALID CARD NUMBER',
        payment_state: 'invalid',
      });
    if (error?.code === 'incorrect_cvc')
      this.setState({
        card_cvv_error_text: 'INVALID CVV',
        payment_state: 'invalid',
      });
    if (error?.code === 'invalid_cvc')
      this.setState({
        card_cvv_error_text: 'INVALID CVV',
        payment_state: 'declined',
      });
    if (
      error?.code === 'invalid_expiry_month' ||
      error?.code === 'invalid_expiry_year'
    )
      this.setState({
        card_expiration_error_text: 'INVALID EXP DATE',
        payment_state: 'invalid',
      });
    if (error?.code === 'incorrect_zip')
      this.setState({
        card_zip_error_text: 'INCORRECT ZIP',
        payment_state: 'invalid',
      });
    if (error?.code === 'card_declined')
      this.setState({
        card_number_error_text: 'CARD DECLINED',
        card_expiration_error_text: 'CARD DECLINED',
        card_cvv_error_text: 'CARD DECLINED',
        payment_state: 'declined',
      });
    if (error?.code === 'expired_card')
      this.setState({
        card_number_error_text: 'CARD EXPIRED',
        card_expiration_error_text: 'CARD EXPIRED',
        card_cvv_error_text: 'CARD EXPIRED',
        payment_state: 'declined',
      });
    if (error?.code === 'processing_error') {
      // errorAlert(error.meessage);
      this.setState({ payment_state: '' });
    }
    this.changeFromPaymentState();
  }

  // format billing_details for payment creation
  formatBillingDetails = () => {
    const {
      user_email,
      user_name,
      current_user,
      alternate_shirt_address,
      shirt_address_street,
      shirt_address_apartment,
      shirt_address_city,
      shirt_address_state,
      shirt_address_zip,
      card_zip,
    } = this.state;
    const address = {
      'billing_details[address][city]':
        shirt_address_city || current_user.location.city,
      'billing_details[address][country]': this.getCountrySlug(
        current_user?.location?.country,
      ),
      'billing_details[address][line1]':
        shirt_address_street || current_user.location?.address,
      'billing_details[address][line2]':
        shirt_address_apartment || current_user.location?.apartment || '',
      'billing_details[address][postal_code]': card_zip,
      'billing_details[address][state]':
        shirt_address_state || current_user.location?.address_state,
    };
    const userInfo = {
      'billing_details[email]': user_email,
      'billing_details[name]': user_name,
      'billing_details[phone]': current_user.phone || null,
    };

    let addressBody = [];
    for (let property in address) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(address[property]);
      addressBody.push(encodedKey + '=' + encodedValue);
    }
    let userBody = [];
    for (let property in userInfo) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(userInfo[property]);
      userBody.push(encodedKey + '=' + encodedValue);
    }
    let fullBody = addressBody;
    fullBody = fullBody.concat(userBody);
    fullBody = fullBody.join('&');

    return fullBody;
  };

  createPaymentIntent = () => {
    let payload = {
      purchase_choice_id: this.state.id,
      product: paymentConfig.paymentProduct,
      description: this.state.title,
      receipt_email: this.state.user_email,
    };
    return rwbApi
      .createPaymentIntent(JSON.stringify(payload))
      .then((result) => {
        this.clientSecret = result.intent_information.client_secret;
        return result;
      })
      .catch((error) => {
        if (
          error?.error?.message ===
          'Parameter receipt_email contains an invalid email address'
        ) {
          this.setState({
            email_error_text: 'INVALID EMAIL ADDRESS',
            payment_state: '',
          });
        } else {
          // errorAlert(GENERIC_ERROR);
          alert(GENERIC_ERROR)
          this.setState({
            payment_state: '',
          });
        }
      });
  };

  createPayment = () => {
    let payload = {
      purchase_choice: this.state.id,
      amount_paid: this.state.amount_paid,
      expiration_date: this.state.expiration_date,
    };
    return rwbApi
      .createPayment(JSON.stringify(payload))
      .then((result) => {
        rwbApi.getUser()
          .then((result) => {
            userProfile.saveToUserProfile(result);
          })
        return result;
      })
      .catch((error) => {
        this.updateErrorStateFromServer(error.error);
      });
  };

  updatePaymentIntent = (paymentRecord) => {
    const formBody = `payment_method=${paymentRecord.id}&client_secret=${this.clientSecret}`;
    return confirmPaymentIntent(formBody, this.payment_intent_id)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        this.setState({
          payment_state: '',
        })
        this.updateErrorStateFromServer(error.error);
      });
  };

  makePaymentMethod = () => {
    const { card_number, card_expiration, card_cvv } = this.state;
    const month = card_expiration.split('/')[0];
    const year = card_expiration.split('/')[1];
    const cardDetails = {
      'card[number]': card_number,
      'card[exp_month]': month,
      'card[exp_year]': year,
      'card[cvc]': card_cvv,
    };
    let formBody = [];
    for (let property in cardDetails) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(cardDetails[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    const billing_details = this.formatBillingDetails();
    return createPaymentMethod(formBody, billing_details)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        this.updateErrorStateFromServer(error.error);
      });
  };
  makePaymentMethod = () => {
    const { card_number, card_expiration, card_cvv } = this.state;
    const month = card_expiration.split('/')[0];
    const year = card_expiration.split('/')[1];
    const cardDetails = {
      'card[number]': card_number,
      'card[exp_month]': month,
      'card[exp_year]': year,
      'card[cvc]': card_cvv,
    };
    let formBody = [];
    for (let property in cardDetails) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(cardDetails[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    const billing_details = this.formatBillingDetails();
    return createPaymentMethod(formBody, billing_details)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        this.updateErrorStateFromServer(error.error);
      });
  };
  createIntent = () => {
    const {
      shipping_country,
      shirt_address_city,
      shirt_address_state,
      shirt_address_street,
    } = this.state;
    if (
      paymentConfig.hasShipment && this.getCountrySlug(shipping_country) !== 'US' &&
      !isMilitaryAddress(
        shirt_address_street,
        shirt_address_city,
        shirt_address_state,
      )
    ) {
      // errorAlert(INTERNATIONAL_ADDRESS_ERROR);
      this.setState({ payment_state: 'invalid' });
      this.changeFromPaymentState();
    } else {
      // Have the user update the payment intent they already made instead of creating a new one
      if (this.payment_intent_id === '') {
        this.createPaymentIntent().then((initialPI) => {
          if (initialPI) {
            this.payment_intent_id = initialPI.intent_information.id;
            this.user_id = initialPI.intent_information.metadata.user_id;
            this.setState({ expiration_date: initialPI.intent_information.expires })
            this.setState({ amount_paid: initialPI.intent_information.amount })
            this.makePayment();
          }
        });
      } else this.makePayment();
    }
  };
  storeConfirmationData = (paymentIntent) => {
    logPayForShirt();
    this.receiptEmail = paymentIntent.receipt_email;
  };

  makePayment = () => {
    this.makePaymentMethod().then((paymentRecord) => {
      if (paymentRecord) {
        this.updatePaymentIntent(paymentRecord)
          .then((updatedPI) => {
            this.createPayment()
            if (!updatedPI.next_action) {
              this.setState({ payment_state: 'complete' });
              this.storeConfirmationData(updatedPI);
              this.changeFromPaymentState();
            }
            // card requires stripe 3D auth
            else {
              this.setState({
                validationURL: updatedPI.next_action.use_stripe_sdk.stripe_js,
              });
            }

          })
          .catch((error) => { });
      }
    }).catch((error) => { });;
  };

  changeFromPaymentState = () => {
    const paymentState = this.state.payment_state;
    if (paymentState === 'invalid' || paymentState === 'declined') {
      setTimeout(() => {
        this.setState({ payment_state: '' });
      }, 3000);
    } else if (paymentState === 'complete') {
      this.setState({ paymentState: 'complete' });

      let data = {
        receiptEmail: this.receiptEmail,
        price: this.state.price,
        icon: this.state.icon,
        title: this.state.title,
      }
      this.props.history.push({
        pathname: '/orderconfirmationview',
        state: data,
      });
    }
  };

  displayPaymentStatus() {
    const { payment_state } = this.state;
    if (!payment_state) return `PAY $${this.state.price}`;
    else if (payment_state === 'invalid') return 'INVALID';
    else if (payment_state === 'declined') return 'DECLINED';
    else if (payment_state === 'authorizing') return 'AUTHORIZING';
    else return 'COMPLETE';
  }
  selectButtonType() {
    const { payment_state } = this.state;
    if (
      !payment_state ||
      payment_state === 'invalid' ||
      payment_state === 'declined'
    )
      return 'primary';
    else if (payment_state === 'authorizing') return 'secondary';
    else return 'tertiary';
  }
  onShirtSizePickerDismiss = (selectedShirtSize) => {
    this.setState({ shirt_size: selectedShirtSize.target.value });
  }

  verifyAddress(complete_callback) {
    let { fullAddress } = this.state;
    let country = this.state.shipping_country;
    if (!country.length) {
      this.setState({ shirt_country_error: 'Please select a country' });
    } else {
      this.setState({ shirt_country_error: undefined });
    }
    if (this.state.address_type === 'domestic') {
      country = 'United States';
      this.setState({ shipping_country: country });
    }
    if (fullAddress && fullAddress.length && country.length) {
      if(fullAddress.includes('REPLACEME'))
      {
        fullAddress = fullAddress.replace(
          'REPLACEME',
          this.state.shirt_address_apartment,
        )
      }
      else{
        fullAddress = null
      }
      melissaVerify(country, fullAddress, complete_callback).then((result) => {
        this.setState({
          error_string: result.error_string,
          shirt_address_street: result.address_street,
          shirt_address_city: result.city,
          shirt_address_zip: result.zip,
          shirt_address_state: result.address_state,
          address_not_verified: result.address_not_verified,
        });
      });
    }
  }



  fetchOptions = (value) => {
    let { country, address_type } = this.state;
    const api = address_type === 'domestic' ? 'freeform' : 'globalfreeform';
    return melissaLookup(api, value, country);
  };

  updateOptionsSingular = (value) => {
    const thisFetchOptions = this.fetchOptions(value)
      .then((data) => {
        const options = data.map((option) => ({ key: option }));
        this.setState({
          addressSuggestions: options,
        });
      })
      .catch((err) =>
        this.setState({ error_string: 'Could not get the address.' }),
      );
  };

  updateOptions = debounce(this.updateOptionsSingular, DEBOUNCE_MS);

  selectAddressHandler = (response) => {
    if (response) {
      const { city, state, zip, street, fullAddress } = response;
      // empty suite lists have empty strings as the first index
      if (response?.suiteList?.length > 1)
        this.setState({
          showApartmentModal: true,
          apartmentList: response.suiteList,
        });
      else this.setState({ apartment: '' });
      this.setState({
        shirt_address_city: city,
        shirt_address_apartment: fullAddress,
        shirt_address_state: state,
        shirt_address_zip: zip,
        shirt_address_street: street,
        fullAddress: `${street}, ${city} ${state} ${zip}`,
        addressSuggestions: [],
      });
    }
  };
  render() {
    const { id, title, price, icon } = this.props.location.state;
    const {
      shirt_address_city,
      shirt_address_state,
      shirt_address_street,
      shirt_address_apartment,
      shirt_address_zip,
      current_user,
      alternate_shirt_address,
      manual_shirt_address,
      user_email,
      user_name,
      card_number,
      card_expiration,
      card_cvv,
      card_zip,
      shirt_size,
      email_error_text,
      alternate_shirt_address_text,
      shirt_address_city_error_text,
      shirt_address_state_error_text,
      shirt_address_general_error_text,
      shirt_address_street_error_text,
      shirt_address_zip_error_text,
      shirt_size_error_text,
      card_number_error_text,
      card_cvv_error_text,
      card_expiration_error_text,
      card_zip_error_text,
      card_name_error_text,
      shipping_country,
      country_error,
      manual_address_entry,
      address_type,
      fullAddress,
      error_string,
      addressSuggestions,
      showShirtSizeModal

    } = this.state;

    let address_string = 'Street';
    let state_string = 'State';
    let zip_string = 'Zip';
    let city_string = 'City';
    let apartment_string = 'Apartment';

    if (
      this.state.address_type === 'international' &&
      shipping_country.toLowerCase() !== 'united states'
    ) {
      address_string = 'Street';
      state_string = 'Administrative Area';
      zip_string = 'Postal Code';
      city_string = 'Locality';
    }
    const shipping_address = alternate_shirt_address
      ? `${city_string}: ${shirt_address_city} <br />${state_string}: ${shirt_address_state} <br />${address_string}: ${shirt_address_street}${!isNullOrEmpty(shirt_address_apartment)
        ? ` <br />${apartment_string}: ${shirt_address_apartment}`
        : ''
      } <br />${zip_string}: ${shirt_address_zip} <br/> Country: ${shipping_country}`
      : `${city_string}: ${current_user.location.city} <br />${state_string}: ${current_user.location.address_state
      } <br />${address_string}: ${current_user.location.address}${!isNullOrEmpty(current_user.location.apartment)
        ? ` <br />${apartment_string}: ${current_user.location.apartment}`
        : ''
      } <br />${zip_string}: ${current_user.location.zip}  <br />Country: ${current_user.location.country || shipping_country
      }`;
    const addressLines = shipping_address.split('<br />').filter(line => line.trim() !== '');

    return (
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className="title">{paymentConfig.appSettingsMembershipLabel}</h3>

        </div>
        <div className={styles.contentContainer}>
          <div className={[styles.centerDiv]}>
            <h2 className={[styles.titleDiv]}>{title}</h2>
            <p className={[styles.paymentDiv]}>{`${paymentConfig.membershipValidityText
              } ${this.getMembershipExpireDate()}`}</p>
            <p className={[styles.paymentRow]}><strong>{`$${price}`}</strong></p>
          </div>


          {paymentConfig.hasShipment && <div>
            <div className={[styles.imgCenter]}>
              <img src={require('../../../../shared/project-info/images/RWBRedShirt.jpg')} />
            </div>
            <div className={[styles.selectBoxRow]}>
              <div className={[styles.selectBoxSize]}>
                <p><strong>Size</strong></p>
                <select value={this.state.shirt_size ? this.state.shirt_size : ""} className={[styles.selectSize]} onChange={(event) => this.onShirtSizePickerDismiss(event)}>
                  {sizes_radio_props.map((item, index) => {
                    return <option value={item.value} key={index}>{item.value}</option>
                  })}
                </select>
              </div>
              <span
                className={`link ${styles.clickable}`}
                onClick={() => {
                  this.setState({
                    showShirtSizeModal: true
                  })
                }
                }>
                Size Chart
              </span>
            </div>
            <p className={[styles.errorText]}>{shirt_size_error_text}</p>
            <div className={[styles.shippingAddressRow]}>
              <p className={[styles.shippingAddressLabel]}><strong>Shipping Address</strong></p>
              <div className={[styles.shippingAddressFlex]}>
                <div>
                  <div className={[styles.switchBox]}>
                    <input value={alternate_shirt_address} onChange={(event) => this.setState({
                      alternate_shirt_address: !this.state.alternate_shirt_address,
                      address_type: ""
                    })} type={"checkbox"} />
                    <span className={[styles.sliderBox]}></span>
                  </div>
                </div>
                <p>
                  Please ship my shirt to an address that is different than my
                  mailing address.
                </p>
              </div>
            </div>
            {alternate_shirt_address &&
              <RadioForm
                className={styles.radioForm}
                inline
                radioProps={address_type_radio_props}
                label={'Address Type'}
                name={'address_type'}
                error={''}
                value={address_type}
                onValueChange={(value) => {
                  this.setState(
                    {
                      manual_address_entry: false,
                      address_type: value,
                      needsToSave: true,
                    },
                    () => {
                      this.verifyAddress();
                    },
                  );
                }}
              />}
            <div>
              {this.state.address_type === 'international' ?
                <div
                  className={styles.clickable}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ showCountryModal: true });
                  }}>
                  <TextInput
                    label={'Country'}
                    value={shipping_country}
                    onValueChange={(text) => { }}
                  />
                </div>

                : null}
               {country_error !=="" && <p className={[styles.errorText]}>{country_error}</p> }
              {alternate_shirt_address && !manual_shirt_address ? (
                <div>
                  <TextInput
                    label={'ADDRESS'}
                    value={fullAddress}
                    error={error_string}
                    onValueChange={(event) => {
                      const { value } = event.target;
                      this.setState({ fullAddress: value });
                      if (value && value.length > 3) {
                        this.updateOptions(value);
                      }
                    }}
                  />
                   {shirt_address_general_error_text ? (
                       <p className={[styles.errorText]}>
                          {shirt_address_general_error_text}
                          </p>
                        
                      ) : null}
                  {fullAddress.length > 0 && Array.isArray(addressSuggestions) && addressSuggestions.length > 0 && (
                    <AddressesList
                      addressSuggestions={addressSuggestions}
                      onSelect={this.selectAddressHandler}
                    // onCurrentLocationSelect={
                    //   this.selectCurrentLocationHandler
                    // }
                    />
                  )}
                  <p>
                    Type the first few characters of you address in the box and
                    then select from the list of matching addresses, or{' '}
                    <span
                      className={`link ${styles.clickable}`}
                      onClick={() =>
                        this.setState({ manual_shirt_address: true })
                      }>
                      manually enter your address.
                    </span>
                  </p>

                </div>
              )
                : null}
              {alternate_shirt_address && manual_shirt_address ? (
                <div>
                  <TextInput
                    label={address_string}
                    value={shirt_address_street ? shirt_address_street : ''}
                    error={shirt_address_street_error_text}
                    onValueChange={(text) => {
                      this.setState({
                        shirt_address_street: text.target.value,
                        needsToSave: true,
                      });
                    }}
                  />
                  <TextInput
                    label={apartment_string}
                    value={shirt_address_apartment ? shirt_address_apartment : ''}
                    error={null}
                    onValueChange={(text) => {
                      this.setState({
                        shirt_address_apartment: text.target.value,
                        needsToSave: false,
                      });
                    }}
                  />
                  <TextInput
                    label={city_string}
                    value={shirt_address_city ? shirt_address_city : ''}
                    error={shirt_address_city_error_text}
                    onValueChange={(text) => {
                      this.setState({
                        shirt_address_city: text.target.value,
                        needsToSave: true,
                      });
                    }}
                  />
                  <TextInput
                    label={state_string}
                    value={shirt_address_state ? shirt_address_state : ''}
                    error={shirt_address_state_error_text}
                    onValueChange={(text) => {
                      this.setState({
                        shirt_address_state: text.target.value,
                        needsToSave: true,
                      });
                    }}
                  />
                  <TextInput
                    label={zip_string}
                    value={shirt_address_zip ? shirt_address_zip : ''}
                    error={shirt_address_zip_error_text}
                    onValueChange={(text) => {
                      this.setState({
                        shirt_address_zip: text.target.value,
                        needsToSave: true,
                      });
                    }}
                  />
                  {manual_shirt_address && (
                    <span
                      className={`link ${styles.clickable}`}
                      onClick={() => this.setState({ manual_shirt_address: false })}>
                      Use Auto Complete
                    </span>
                  )}
                   {shirt_address_general_error_text && manual_shirt_address ? (
                  <p className={[styles.errorText]}>{shirt_address_general_error_text}</p>
                   
                ) : null}
                </div>
              ) : null}
            </div>

            {/* country picker modal  */}
            <div>
              <Modal
                open={this.state.showCountryModal}
                onClose={() => { }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box>
                  <div className={styles.container}>
                    <div className={styles.modalContentContainer}>
                      <div>
                        <h5 className={[styles.modalHead]}><strong>Country</strong></h5>
                        <div className={[styles.countriesList]}>
                          {Object.values(COUNTRY_OPTIONS).map((item, index) => {
                            return <h2
                              key={index}
                              // className={[
                              //   styles.h2,
                              //   item === selectedValue && styles.selected,
                              // ].join(' ')}
                              onClick={() => {
                                this.setState({
                                  shipping_country: item.display,
                                  showCountryModal: false
                                })
                              }}>
                              {item.display}
                            </h2>
                          })}


                        </div>
                      </div>
                      <div style={{ width: "80%", alignSelf: 'center' }}>


                        <CustomButton
                          // link={true}
                          onClick={() => {
                            this.setState({
                              showCountryModal: false
                            })
                          }}


                          // onPress={()=>{this.setState({
                          //   showCountryModal:false
                          // })}}
                          label="Cancel"
                          buttonStyle="secondary"
                        />
                      </div>
                    </div>
                  </div>

                </Box>
              </Modal>
            </div>
            {/* size chart  */}
            <div>
              {showShirtSizeModal && <ShirtSizesModal
                isOpen={showShirtSizeModal}
                modalHandler={() => this.setState({ showShirtSizeModal: false })}
              />
              }

            </div>
            { addressLines.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
          </div>}

        
          <div className={styles.formContainer}>
            <TextInput
              label={'Email'}
              error={email_error_text}
              value={user_email}
              onValueChange={(event) => this.valueChangeHandler(event, 'user_email')}
              autoFillLabel="given-name"
            />
            <TextInput
              label={'Name on card'}
              error={card_name_error_text}
              value={user_name}

              onValueChange={(event) => this.valueChangeHandler(event, 'user_name')}
              autoFillLabel="given-name"
            />
            <TextInput
              label={'Card Number'}
              error={card_number_error_text}
              value={this.displayCardNumber(card_number)}
              onValueChange={(event) => this.setCardNumber(event)}
              autoFillLabel="given-name"

            />
            <div className={[styles.expRow]}>
              <TextInput
                label={'EXP DATE (MM/YY)'}
                error={card_expiration_error_text}
                value={this.setExpirationDate(card_expiration)}
                onValueChange={(event) => this.valueChangeHandler(event, 'card_expiration')}
                autoFillLabel="given-name"
              />
              <TextInput
                label={'Cvv'}
                error={card_cvv_error_text}
                value={card_cvv}
                onValueChange={(event) => this.handleCardCvv(event)}
                autoFillLabel="given-name"
              />
            </div>
            <TextInput
              label={'Zip'}
              error={card_zip_error_text}
              value={card_zip}
              onValueChange={(event) => this.valueChangeHandler(event, 'card_zip')}
              autoFillLabel="given-name"
            />
          </div>

          <div className={styles.buttonContainer}>
            <CustomButton
              onClick={() => { this.validateInput() }}
              label={this.displayPaymentStatus()}
              buttonStyle={this.selectButtonType()}
              disabled={this.state.payment_state !== ''}
            />
            <CustomButton
              link={true}
              to="/membershipoptionview"
              label="Back"
              buttonStyle="secondary"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(PaymentView)